<template>
    <div class="default-textarea" :class="{error: errors.length}">
        <div class="default-textarea__body">
            <textarea class="default-textarea__textarea"
                      :disabled="disabled"
                      :placeholder="placeholder"
                      rows="1"
                      v-model="value"
            />
            <label class="default-textarea__label">{{ label }}</label>
        </div>
        <div class="default-textarea__error" v-if="errors.length">
            <span>{{ errors[0].$message }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "InputTextarea",
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: [String, Number],
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    }
}
</script>

<style scoped>

</style>